import Http from '../utils/axios'
const rt = '/api-zendai'
const user = '/user'
const auth = '/noauth'
export default {
    //OA验权接口
    gaoliUnionLogin(params){
        return Http.post(`${rt}${user}/e/zjssoLogin`,params, false)
    },
    // 获取重定向参数
    getZjInfo() {
        return Http.get(`${rt}${auth}/user/getZjInfo`,'', false)
    }
}
